import { MenuItem, TextField } from '@mui/material';

type Props = {
  value: string;
  onChange: (value: string) => void;
  /** Варианты очереди; null — очередь не выбрана, выбирать не из чего */
  options: { key: string; name: string }[] | null;
  ariaLabel: string;
};

/** Выбор из справочника очереди по ключу: тип, статус */
const KeySelect: React.FC<Props> = ({ value, onChange, options, ariaLabel }) => (
  <TextField
    select
    size="small"
    fullWidth
    disabled={!options}
    value={value}
    onChange={(event) => onChange(event.target.value)}
    slotProps={{ select: { displayEmpty: true, SelectDisplayProps: { 'aria-label': ariaLabel } } }}
  >
    {!options && <MenuItem value="">Сначала выберите очередь</MenuItem>}
    {options?.map((option) => (
      <MenuItem key={option.key} value={option.key}>
        {option.name}
      </MenuItem>
    ))}
  </TextField>
);

export { KeySelect };
